import { useQuery } from '@tanstack/react-query';
import { Code } from 'lucide-react';
import { queryKeys } from '@/hooks/react-query/queryKeys';
import { getDocumentTemplatePreviewHtml } from '@/services/templateService';
import { DocumentTemplateList } from '@/types/template';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DocumentTemplateSourceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  template: DocumentTemplateList | null;
}

export function DocumentTemplateSourceDialog({
  open,
  onOpenChange,
  template,
}: DocumentTemplateSourceDialogProps) {
  const { data: previewData } = useQuery({
    queryKey: queryKeys.templates.documentPreviewHtml(template?.id ?? ''),
    queryFn: () => getDocumentTemplatePreviewHtml(template!.id),
    enabled: open && !!template?.id && !template?.html_content,
  });

  const displaySource =
    template?.html_content ?? previewData?.html ?? 'Loading...';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Code className="h-5 w-5" />
            Source: {template?.name}
          </DialogTitle>
        </DialogHeader>
        <pre className="bg-muted rounded-md p-4 text-sm font-mono overflow-x-auto whitespace-pre-wrap leading-relaxed border max-h-[60vh] overflow-y-auto">
          {displaySource}
        </pre>
      </DialogContent>
    </Dialog>
  );
}
